export const types = {
  THEME: '@THEME/CHANGE',
  THEMEING: '@THEMEING/CHANGE',
  NAVIGATION_MODE: '@NAVIGATION_MODE'
};
